export default __webpack_public_path__ + "static/media/logo4.b9fffcd1.png";